import { render } from "./CardsPage.vue?vue&type=template&id=ccf8807e&scoped=true"
import script from "./CardsPage.vue?vue&type=script&lang=js"
export * from "./CardsPage.vue?vue&type=script&lang=js"

import "./CardsPage.vue?vue&type=style&index=0&id=ccf8807e&scoped=true&lang=css"

import exportComponent from "/home/learnbil/public_html/learnbilly.com/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccf8807e"]])

export default __exports__